import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Hospital } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_HOSPITAL_BY_ID_KEY = 'get-hospital-by-id';

export const useGetHospitalById = (hospitalId: number) => {
  return usePermittedQuery<Hospital>(
    [ACCOUNT_TYPE.ADMIN, ACCOUNT_TYPE.ORG_ADMIN, ACCOUNT_TYPE.HOS_ADMIN],
    () => `/hospital/${hospitalId}`,
    {},
    [GET_HOSPITAL_BY_ID_KEY],
    {
      enabled: typeof hospitalId === 'number' && hospitalId >= 0,
    },
  );
};
